import { Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { ExportReportBetsModel } from '../../model';

export const createExportReportBets = (model: ExportReportBetsModel) => {
	const ExportReportShiftButton = () => {
		const { t } = useTranslation();
		const exportButtonClicked = useUnit(model.exportButtonClicked);

		return <Button onClick={exportButtonClicked}>{t('export-report-bets.export-excel')}</Button>;
	};

	return ExportReportShiftButton;
};
